export var  GLOBAL={
  url:'http://appfacturando.orthofam.com.mx/'
  // url:'http://localhost:8080/facturaAppi/public/'
}
